const API_URL = process.env.REACT_APP_API_URL;

const api = {
  // ===== AUTH =====
 checkSession: async () => {
    console.log('🔍 checkSession CALLED');
    console.trace('📍 Called from:'); // ✅ Mostra lo stack trace
    
    const res = await fetch(`${API_URL}/auth/check_session.php`, { 
      credentials: 'include' 
    });
    return res.json();
  },

  login: async (data) => {
    const res = await fetch(`${API_URL}/auth/login.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  logout: async () => {
    await fetch(`${API_URL}/auth/logout.php`, {
      method: 'POST',
      credentials: 'include'
    });
  },

  // ===== EVENTS =====
  getEvents: async () => {
    const res = await fetch(`${API_URL}/events/list.php`, { 
      credentials: 'include' 
    });
    return res.json();
  },

  createEvent: async (eventData) => {
    const res = await fetch(`${API_URL}/events/create.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData)
    });
    return res.json();
  },

  updateEventStatus: async (event_id, status) => {
    const res = await fetch(`${API_URL}/events/update_status.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_id, status })
    });
    return res.json();
  },
    
  updateEvent: async (eventId, eventData) => {
    const res = await fetch(`${API_URL}/events/update.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: eventId, ...eventData })
    });
    return res.json();
  },

  softDeleteEvent: async (event_id) => {
    const res = await fetch(`${API_URL}/events/soft_delete.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_id })
    });
    return res.json();
  },

  deleteEvent: async (eventId) => {
  const res = await fetch(`${API_URL}/events/delete.php`, {
    method: 'POST',
    credentials: 'include',
    headers: { 
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ event_id: eventId })
  });
  return res.json();
},

  // ===== CLIENTS =====
  getClientsByEvent: async (eventId) => {
    const res = await fetch(`${API_URL}/clients/list.php?event_id=${eventId}`, { 
      credentials: 'include' 
    });
    return res.json();
  },

  createClient: async (clientData) => {
    const res = await fetch(`${API_URL}/clients/create.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(clientData)
    });
    return res.json();
  },

  assignClient: async (data) => {
    const res = await fetch(`${API_URL}/clients/assign.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },
 
  updateClientStatus: async (event_id, client_id, status) => {
    const res = await fetch(`${API_URL}/clients/update_status.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_id, client_id, status })
    });
    return res.json();
  },


  updateClient: async (clientData) => {
    const res = await fetch(`${API_URL}/clients/update_client.php`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(clientData),
    });
    return res.json();
  },

  deleteParticipation: async (event_id, client_id) => {
    const res = await fetch(`${API_URL}/clients/delete_participation.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_id, client_id })
    });
    return res.json();
  },

  // ===== AREAS =====
  getAreas: async () => {
    const res = await fetch(`${API_URL}/areas/list.php`, { 
      credentials: 'include' 
    });
    return res.json();
  },

  // ===== EVENT AREA TARGETS =====
  getEventAreaTargets: async (eventId) => {
    const res = await fetch(`${API_URL}/event_area_targets/list.php?event_id=${eventId}`, { 
      credentials: 'include' 
    });
    return res.json();
  },

  // Imposta/Aggiorna target per area (UPSERT)
  // Crea nuovi record o aggiorna esistenti
    setEventAreaTargets: async (event_id, targets) => {
      const res = await fetch(`${API_URL}/event_area_targets/set_targets.php`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_id, targets })
      });
      return res.json();
    },
    getEkinextProducts: async () => {
    const res = await fetch(`${API_URL}/ekinext/get_products.php`, {
      credentials: 'include'
    });
    return res.json();
  },

  createEkinextProduct: async (data) => {
    const res = await fetch(`${API_URL}/ekinext/create_product.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  updateEkinextProduct: async (data) => {
    const res = await fetch(`${API_URL}/ekinext/update_product.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  deleteEkinextProduct: async (id) => {
    const res = await fetch(`${API_URL}/ekinext/delete_product.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id })
    });
    return res.json();
  },

  getEkinextProductDetails: async (id) => {
    const res = await fetch(`${API_URL}/ekinext/get_product_details.php?id=${id}`, {
      credentials: 'include'
    });
    return res.json();
  },

  addEkinextClient: async (data) => {
    const res = await fetch(`${API_URL}/ekinext/add_client.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  updateEkinextClientStatus: async (data) => {
    const res = await fetch(`${API_URL}/ekinext/update_client_status.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  addEkinextFeedback: async (data) => {
    const res = await fetch(`${API_URL}/ekinext/add_feedback.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  updateEkinextFeedback: async (data) => {
    const res = await fetch(`${API_URL}/ekinext/update_feedback.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    return res.json();
  },

  deleteEkinextFeedback: async (id) => {
    const res = await fetch(`${API_URL}/ekinext/delete_feedback.php`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id })
    });
    return res.json();
  }
};

export default api;
